import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';

import { Container } from './styles';
import Loading from '~/components/Loading';
import api from '~/services/api';
import { useAuth } from '~/hooks/Auth';

const AutoLogin: React.FC = () => {
  const params = useParams<{ token: string }>();
  const history = useHistory();
  const { setAutoLoginData } = useAuth();

  useEffect(() => {
    api
      .get('users/sessions/get-login', {
        params: { token: params.token, type: 'Organizador' },
      })
      .then((response) => {
        const { token, user } = response.data;

        localStorage.setItem('@Koro:token', token);
        localStorage.setItem('@Koro:user', JSON.stringify(user));

        api.defaults.headers.authorization = `Bearer ${token}`;

        setAutoLoginData({ token, user });
        history.push('/inicio');
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao logar',
          text: error.response.data.message,
        }).then(() => {
          window.close();
        });
      });
  }, [history, params.token, setAutoLoginData]);

  return (
    <Container>
      <Loading active text="Logando..." />
    </Container>
  );
};

export default AutoLogin;
